import { jsx as o } from "react/jsx-runtime";
import { useState as t } from "react";
import { Icon as a } from "../Icon/Icon.js";
import '../../../assets/PasswordVisibilityToggle.css';const r = "_visibilityToggle_2k2az_4", n = "_circleBackground_2k2az_19", d = "_icon_2k2az_23", e = {
  visibilityToggle: r,
  circleBackground: n,
  icon: d
}, u = () => {
  const [i, s] = t(!1);
  return {
    isPasswordVisible: i,
    handlePasswordVisibility: () => {
      s(!i);
    }
  };
}, y = ({
  testId: i,
  iconName: s,
  visibilityToggleLabel: l,
  handlePasswordVisibility: c
}) => /* @__PURE__ */ o(
  "button",
  {
    className: e.visibilityToggle,
    "data-testid": i,
    "aria-label": l,
    onClick: c,
    children: /* @__PURE__ */ o("div", { className: e.circleBackground, children: /* @__PURE__ */ o(a, { className: e.icon, name: s, size: 16 }) })
  }
);
export {
  y as PasswordVisibilityToggle,
  u as useTogglePasswordVisibility
};
